import { render } from "./ProfilesList.vue?vue&type=template&id=c864a7d8"
import script from "./ProfilesList.vue?vue&type=script&lang=js"
export * from "./ProfilesList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__